import { request } from "@/interface/helper";

const str = "HotWords";

export const HotWords = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/hotwords/list" }),
    add: data => request({ data, method: "post", url: "/hotwords/add" }),
    detail: data => request({ data, method: "post", url: "/hotwords/detail" }),
    edit: data => request({ data, method: "post", url: "/hotwords/modify" }),
    transfer: data => request({ data, method: "get", url: "/hotwords/transfer" }),
  }
};
